module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-bottom-6a57e4822d39df1ae5d400830d0efaad.svg";